export default __webpack_public_path__ + "static/media/logo_lang.a138c0d3.svg";